import {Decoder, oneOf} from 'json-bouncer'
import {InquiryOfferStatus, offerStatusDecoder} from './InquiryOfferStatus'
import {
    InquiryProofCopyStatus,
    proofCopyStatusDecoder
} from './InquiryProofCopyStatus'

export type InquiryStatus = InquiryOfferStatus | InquiryProofCopyStatus

export function inquiryStatusDecoder(): Decoder<InquiryStatus> {
    return oneOf([
        offerStatusDecoder(),
        proofCopyStatusDecoder()
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryStatus.ts